export function log(message: string, params?: any) {
  if (params && params.message && params.message === "DO_NOT_LOG") return;
  console.log(message, params);
}
